import React, { useCallback, useEffect, useState } from 'react';

import config from '@/utils/config';
import {
  GEO_LOCATOR_CITY_SELECTED_EVENT,
  GEO_LOCATOR_EVENTS_CHANNEL,
} from '@/constants/events';
import {
  CREDIT_CALCULATOR_CHANNEL,
  CREDIT_CALCULATOR_PROGRAM_SELECTED_EVENT,
} from '@/apps/credit-form/constants/events';
import { TCreditPayload } from '@/apps/credit-form/types';
import { TEventDetail } from '@/types/common';
import CreditForm from './CreditForm';

import style from './style.module.scss';

type AppProps = any;

const App: React.VFC<AppProps> = () => {
  const [creditDetail, setCreditInfo] = useState<TCreditPayload | null>(null);

  const isHiddenForm = !creditDetail;

  const handleProgramSelected = useCallback(
    (e: CustomEvent<TEventDetail<Partial<TCreditPayload>>>) => {
      const { detail } = e;
      if (detail?.type === CREDIT_CALCULATOR_PROGRAM_SELECTED_EVENT) {
        setCreditInfo(
          !!detail?.program && !!detail?.parameters
            ? {
                parameters: detail.parameters,
                program: detail.program,
              }
            : null,
        );
      }
    },
    [],
  );

  const handleCitySelected = useCallback(
    (e: CustomEvent<TEventDetail<Partial<{ city: string | null }>>>) => {
      const { detail } = e;
      if (detail?.type === GEO_LOCATOR_CITY_SELECTED_EVENT) {
        config.set({
          initialValues: {
            ...config.get('initialValues'),
            city: detail.city,
          },
        });
      }
    },
    [],
  );

  useEffect(() => {
    const listener = handleProgramSelected as EventListener;
    document.addEventListener(CREDIT_CALCULATOR_CHANNEL, listener);
    return () => {
      document.removeEventListener(CREDIT_CALCULATOR_CHANNEL, listener);
    };
  }, [handleProgramSelected]);

  useEffect(() => {
    const listener = handleCitySelected as EventListener;
    document.addEventListener(GEO_LOCATOR_EVENTS_CHANNEL, listener);
    return () => document.removeEventListener(GEO_LOCATOR_EVENTS_CHANNEL, listener);
  }, [handleCitySelected]);

  if (isHiddenForm) {
    return null;
  }

  return (
    <div
      className={cn(style.widget, config.get('widgetClassName'))}
      style={config.get('widgetStyle')}
    >
      <div className={style.container}>
        <CreditForm details={creditDetail} />
      </div>
    </div>
  );
};

export default App;
